import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import PageLayout from "examples/LayoutContainers/PageLayout";

// Pricing page components
import Header from "views/root/components/Header";
import Footer from "views/root/components/Footer";
import TransmissionCards from "views/root/components/TransmissionCards";
import TrustedBrands from "views/root/components/TrustedBrands";
import Faq from "views/root/components/Faq";

function RootPage() {
  return (
    <PageLayout>
      <Header />
      <Container>
        <TransmissionCards />
        {/* <TrustedBrands /> */}
        <Faq />
      </Container>
      <SoftBox mt={8}>
        <Footer />
      </SoftBox>
    </PageLayout>
  );
}

export default RootPage;
